import { AppBar, Toolbar, Button, Box, IconButton, Drawer, List, ListItemButton, ListItemText } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useState } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const btn = (path: string, label: string) => (
    <Button
      component={RouterLink}
      to={path}
      sx={{
        color: "text.primary",
        border: location.pathname === path ? "2px solid" : "2px solid transparent",
        borderColor: location.pathname === path ? "primary.main" : "transparent",
        borderRadius: 1,
        ml: 1,
        "&:hover": {
          borderColor: "primary.main",
        }
      }}
    >
      {label}
    </Button>
  );

  const mobileList = (
    <Box sx={{ width: 250, bgcolor: 'background.paper', height: '100%' }} role="presentation" onClick={() => setOpen(false)}>
      <List>
        <ListItemButton component={RouterLink} to="/">
          <ListItemText primary="Startseite" />
        </ListItemButton>
        <ListItemButton component={RouterLink} to="/kontakt">
          <ListItemText primary="Kontakt" />
        </ListItemButton>
      </List>
    </Box>
  );

  return (
    <AppBar position="sticky">
      <Toolbar
        sx={{
          minHeight: "80px !important",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }} component={RouterLink} to="/">
          <img src="/logo.png" alt="EDEB-Estrichbau" style={{ height: 80, width: "auto", filter: "drop-shadow(0px 0px 12px rgba(255, 255, 255, 0.8)) drop-shadow(0px 0px 4px rgba(255, 255, 255, 1))" }} />
        </Box>

        {/* DESKTOP */}
        <Box sx={{ display: { xs: "none", md: "block" } }}>
          {btn("/", "Startseite")}
          {btn("/kontakt", "Kontakt")}
        </Box>

        {/* MOBILE */}
        <Box sx={{ display: { xs: "block", md: "none" } }}>
          <IconButton onClick={() => setOpen(true)} sx={{ color: "text.primary" }}>
            <MenuIcon />
          </IconButton>
        </Box>

        <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
          {mobileList}
        </Drawer>
      </Toolbar>
    </AppBar>
  );
}
